<div class="row" *ngIf="(tableItem | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="fw-bold">ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.carrierServiceID" disabled />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Description</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.description" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Abbreviation</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.abbreviation" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Used for Load Service Requirements</label>
                <input type="checkbox" id="isLoadServiceRequirement" name="isLoadServiceRequirement" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.isLoadServiceRequirement" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
